const convertStrToArr = (str) => {
    const arr = str.toString().split("");
    while (arr.length < 5) {
        arr.push("");
    }
    return arr.slice(0, 5);
}

export {
    convertStrToArr
}